const HAS_DISCOUNT_PROP = "_has_bundle_discount";

async function patchLineProps(lineKey, quantity, existingProps = {}, hasDisc) {
  const props = { ...existingProps, [HAS_DISCOUNT_PROP]: hasDisc ? true : false }; 
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-Has-Disc-Patch": "1" },
    credentials: "same-origin",
    body: JSON.stringify({ id: lineKey, quantity, properties: props })
  }).catch(console.error);
}

async function removeByKeys(lineKeys = []) {
  const updates = {};
  for (const k of lineKeys) updates[k] = 0;

  const res = await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-Has-Disc-Patch": "1" },
    credentials: "same-origin",
    body: JSON.stringify({ 
      updates: updates, 
      sections: "cart-drawer,cart-icon-bubble"
    }),
  }).then(res => res.json());

  if (!res) throw new Error("Failed to update cart");

  const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
  const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');

  $("#CartDrawer .drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
  $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());

  return res;
}

document.addEventListener("DOMContentLoaded", function() {
  const origFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await origFetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0].url || '';
      if (/\/cart\/(add|change|update)(\?|$)/.test(url)) {
        
        const json = await res.clone().json().catch(() => null);
        if (!json?.items?.length) return res;

        const tasks = [];

        for (const item of json.items) {
          const allocs = item.line_level_discount_allocations || item.discount_allocations || [];
          const hasDisc = allocs.length > 0;
          const flagSet = Boolean(item.properties?.[HAS_DISCOUNT_PROP]);

          if (hasDisc && !flagSet) {
            tasks.push(patchLineProps(item.key, item.quantity, item.properties || {}, true));
          } else if (!hasDisc && flagSet) {
            tasks.push(patchLineProps(item.key, item.quantity, item.properties || {}, false));
          }
        }

        await Promise.allSettled(tasks); 


        if(promo_product.min_amount>(json.total_price/100)){
          let free_gift_items = json.items.filter((i) => i.properties._free_gift);
          let free_gift_items_keys = free_gift_items.map((i) => i.key);
          if(free_gift_items_keys.length>0){
            setTimeout(async () => {
              await removeByKeys(free_gift_items_keys);
            }, 100)
          }
        }

        return res;


      }
    } catch (e) {
      console.error(e)
    }
    return res;
  };
});
